import React, { useContext } from "react";
import ProviderContent from "./contentProvider";
import { ContextContent } from "./contentContext";
import ContentHeader from "./__header";
import ContentFooter from "./__footer";
import Abort404 from "../abort404";
import Abort403 from "../abort403";
import "./styles.css";

// Обёртка контента: шапка (переключатель show/edit), тело, футер (кнопки по типу).
// 404/403 от API — системные страницы вместо контента.
export default function Content({ children, ...other }) {
    return <ProviderContent {...other}>
        <ContentView>{children}</ContentView>
    </ProviderContent>;
}

function ContentView({ children }) {
    const contextContent = useContext(ContextContent);
    if (contextContent.codeApi === 404) return <Abort404/>;
    if (contextContent.codeApi === 403) return <Abort403/>;
    return <div className="content">
        <ContentHeader/>
        <div className="content__body">{children}</div>
        <ContentFooter/>
    </div>;
}
